var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perfect-scrollbar',{staticClass:"item-container"},_vm._l((_vm.itemGroups),function(itemGroup,i){return _c('div',{staticClass:"column",class:{last: i===_vm.items.length-1}},_vm._l((itemGroup),function(item){return _c('item-square',{staticClass:"single-item",attrs:{"big":_vm.big,"small":_vm.small,"show-year":_vm.showYear,"item":item}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }